export default {
  header: {
    hideMenuBar: 'Ascundeți bara de meniu',
    showMenuBar: 'Afișați bara de meniu',
  }
}
